/**
 * Shop with Mike — single-page category funnel.
 * URL: ?path=interior/bucket-seats (hub) or ?path=bucket-seats (landing with funnel_root)
 * Tree: inline JSON from funnel_step blocks (data-funnel-tree)
 */
(function () {
  function parseJson(root, selector) {
    var el = root.querySelector(selector);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function isLeafType(type) {
    return type === 'collection' || type === 'page' || type === 'quiz';
  }

  function getPathFromSearch() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('path');
    if (!raw || String(raw).trim() === '') return [];
    return String(raw)
      .split('/')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function buildSearch(pathSegments) {
    if (!pathSegments.length) return '';
    return '?path=' + encodeURIComponent(pathSegments.join('/'));
  }

  function resolveNode(tree, pathSegments, funnelRoot) {
    if (!tree || !tree.nodes) return { node: null, valid: false };

    if (!pathSegments.length) {
      if (funnelRoot) {
        var scopedRoot = tree.nodes[funnelRoot];
        if (!scopedRoot) return { node: null, valid: false };
        return { node: scopedRoot, valid: true };
      }
      var intro = tree.nodes[tree.rootId];
      if (!intro) return { node: null, valid: false };
      return { node: intro, valid: true };
    }

    var current;
    var walkSegments;

    if (funnelRoot) {
      current = tree.nodes[funnelRoot];
      if (!current) return { node: null, valid: false };
      walkSegments = pathSegments;
    } else {
      current = tree.nodes[tree.rootId];
      if (!current) return { node: null, valid: false };
      walkSegments = pathSegments;
    }

    var i;
    for (i = 0; i < walkSegments.length; i++) {
      var id = walkSegments[i];
      if (!current.children || current.children.indexOf(id) === -1) {
        return { node: null, valid: false };
      }
      current = tree.nodes[id];
      if (!current) {
        return { node: null, valid: false };
      }
    }
    return { node: current, valid: true };
  }

  function parentPath(pathSegments) {
    return pathSegments.slice(0, -1);
  }

  function childPath(pathSegments, childId) {
    return pathSegments.concat([childId]);
  }

  function nodeTitle(node) {
    return node.title || node.id;
  }

  function nodeLeftImage(node) {
    return node.image || '';
  }

  function getMiddleMode(node, root) {
    if (node.middleMode && node.middleMode !== 'inherit') {
      return node.middleMode;
    }
    return root.getAttribute('data-middle-content-mode') || 'none';
  }

  function getMiddleAlign(root) {
    return root.getAttribute('data-middle-icon-align') || 'center';
  }

  function isMiddleEnabledForRow(root) {
    return (root.getAttribute('data-middle-content-mode') || 'none') !== 'none';
  }

  function isMiddleEnabledForCard(root) {
    if ((root.getAttribute('data-middle-content-mode') || 'none') === 'none') return false;
    var attr = root.getAttribute('data-card-show-middle');
    return attr === 'true' || attr === true;
  }

  function nodeMiddleImage(node, root) {
    if (node.middleImage) return node.middleImage;
    return root.getAttribute('data-default-middle-icon') || '';
  }

  function showCollectionBadge(root) {
    var attr = root.getAttribute('data-show-collection-badge');
    return attr === 'true' || attr === true;
  }

  function collectionBadgeText(node, root) {
    if (node.type !== 'collection' || !showCollectionBadge(root)) return '';
    if (node.collectionBadgeText) return node.collectionBadgeText;
    return root.getAttribute('data-collection-badge-label') || 'Collection';
  }

  function isStackedCard(root) {
    return root.getAttribute('data-card-content-layout') === 'stacked';
  }

  function normalizeUrl(url) {
    if (!url) return url;
    var u = String(url).trim();
    if (u.indexOf('shopify://pages/') === 0) {
      return '/pages/' + u.slice('shopify://pages/'.length).replace(/\/$/, '');
    }
    if (u.indexOf('shopify://collections/') === 0) {
      return '/collections/' + u.slice('shopify://collections/'.length).replace(/\/$/, '');
    }
    return u;
  }

  function leafUrl(node, root) {
    if (node.url) return normalizeUrl(node.url);
    if (node.type === 'quiz') {
      var quizUrl = root.getAttribute('data-default-quiz-url');
      return quizUrl || '/pages/quiz';
    }
    if (node.type === 'collection' && node.handle) {
      return '/collections/' + node.handle;
    }
    return '#';
  }

  function leafCtaLabel(root, node) {
    if (node.type === 'collection') {
      return root.getAttribute('data-label-view-collection') || 'View collection';
    }
    return root.getAttribute('data-label-view-page') || 'Continue';
  }

  function chooseLabel(root) {
    return root.getAttribute('data-label-choose') || 'Choose';
  }

  function bootstrapFunnel(root, tree) {
    var introEl = root.querySelector('[data-funnel-intro]');
    var breadcrumbEl = root.querySelector('[data-funnel-breadcrumb]');
    var branchEl = root.querySelector('[data-funnel-branch]');
    var leafEl = root.querySelector('[data-funnel-leaf]');
    var gridEl = root.querySelector('[data-funnel-grid]');
    var stepHeading = root.querySelector('[data-funnel-step-heading]');
    var leafHeading = root.querySelector('[data-funnel-leaf-heading]');
    var leafBody = root.querySelector('[data-funnel-leaf-body]');
    var leafCta = root.querySelector('[data-funnel-leaf-cta]');
    var backWrap = root.querySelector('[data-funnel-back-wrap]');
    var backBtn = root.querySelector('[data-funnel-back]');
    var noticeEl = root.querySelector('[data-funnel-notice]');
    var liveRegion = root.querySelector('[data-funnel-live]');
    var homeLabel = root.getAttribute('data-label-breadcrumb-home') || 'Start';
    var funnelRoot = (root.getAttribute('data-funnel-root') || '').trim();
    var breadcrumbHomeUrl = (root.getAttribute('data-breadcrumb-home-url') || '').trim();
    var comingSoonMsg = root.getAttribute('data-msg-coming-soon') || 'This section is coming soon.';
    var showBackButton = root.getAttribute('data-show-back-button') !== 'false';

    var pathSegments = [];
    // Skip programmatic focus on first paint so homepage doesn't jump to this section
    // or show a focus outline on the intro heading.
    var readyForFocus = false;

    function focusFunnelHeading(el) {
      if (!readyForFocus || !el || !el.focus) return;
      el.focus();
    }

    function setBackVisible(visible) {
      if (!backWrap) return;
      if (visible && showBackButton) {
        backWrap.removeAttribute('hidden');
      } else {
        backWrap.setAttribute('hidden', '');
      }
    }

    function autoRedirectEnabled() {
      var v = root.getAttribute('data-auto-redirect-collection');
      return v === 'true' || v === true;
    }

    function shouldAutoRedirect(node) {
      if (!autoRedirectEnabled() || !node) return false;
      var url = leafUrl(node, root);
      if (!url || url === '#') return false;
      if (node.type === 'collection' || node.type === 'page' || node.type === 'quiz') {
        return true;
      }
      if (node.url) return true;
      return false;
    }

    function redirectToDestination(node) {
      window.location.assign(leafUrl(node, root));
    }

    function announce(msg) {
      if (liveRegion) {
        liveRegion.textContent = '';
        liveRegion.textContent = msg;
      }
    }

    function setNotice(msg) {
      if (!noticeEl) return;
      if (msg) {
        noticeEl.textContent = msg;
        noticeEl.removeAttribute('hidden');
      } else {
        noticeEl.textContent = '';
        noticeEl.setAttribute('hidden', '');
      }
    }

    function updateUrl(path, replace) {
      var url = window.location.pathname + buildSearch(path);
      if (replace) {
        window.history.replaceState({ funnelPath: path.join('/') }, '', url);
      } else {
        window.history.pushState({ funnelPath: path.join('/') }, '', url);
      }
    }

    function renderBreadcrumb(path) {
      if (!breadcrumbEl) return;
      breadcrumbEl.innerHTML = '';

      var ol = document.createElement('ol');
      ol.className = 'koz-shop-with-mike__breadcrumb-list';

      function addHomeCrumb() {
        var li = document.createElement('li');
        li.className = 'koz-shop-with-mike__breadcrumb-item';
        if (breadcrumbHomeUrl) {
          var link = document.createElement('a');
          link.href = breadcrumbHomeUrl;
          link.className = 'koz-shop-with-mike__breadcrumb-link';
          link.textContent = homeLabel;
          li.appendChild(link);
        } else {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'koz-shop-with-mike__breadcrumb-link';
          btn.textContent = homeLabel;
          btn.addEventListener('click', function () {
            navigateTo([], true);
          });
          li.appendChild(btn);
        }
        ol.appendChild(li);
      }

      function addCrumb(label, pathTo, isCurrent) {
        var li = document.createElement('li');
        li.className = 'koz-shop-with-mike__breadcrumb-item';
        if (isCurrent) {
          li.setAttribute('aria-current', 'page');
          li.textContent = label;
        } else {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'koz-shop-with-mike__breadcrumb-link';
          btn.textContent = label;
          btn.addEventListener('click', function () {
            navigateTo(pathTo, true);
          });
          li.appendChild(btn);
        }
        ol.appendChild(li);
      }

      addHomeCrumb();

      if (funnelRoot) {
        var rootNode = tree.nodes[funnelRoot];
        if (rootNode) {
          if (!path.length) {
            addCrumb(nodeTitle(rootNode), [], true);
          } else {
            addCrumb(nodeTitle(rootNode), [], false);
          }
        }
      }

      var acc = [];
      var i;
      for (i = 0; i < path.length; i++) {
        acc.push(path[i]);
        var resolved = resolveNode(tree, acc, funnelRoot);
        if (!resolved.valid || !resolved.node) break;
        var isLast = i === path.length - 1;
        addCrumb(nodeTitle(resolved.node), acc.slice(), isLast);
      }

      breadcrumbEl.appendChild(ol);

      if (funnelRoot || path.length) {
        breadcrumbEl.removeAttribute('hidden');
      } else {
        breadcrumbEl.setAttribute('hidden', '');
      }
    }

    function isMinimalLayout() {
      return root.classList.contains('koz-shop-with-mike--minimal');
    }

    function buildLeftIcon(imgSrc) {
      if (!imgSrc) return null;
      var iconWrap = document.createElement('span');
      iconWrap.className = 'koz-shop-with-mike__row-icon';
      iconWrap.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.className = 'koz-shop-with-mike__row-icon-img';
      img.src = imgSrc;
      img.alt = '';
      img.loading = 'lazy';
      iconWrap.appendChild(img);
      return iconWrap;
    }

    function renderMiddleContent(node, wrapClass) {
      var mode = getMiddleMode(node, root);
      if (mode === 'none' || mode === 'off') return null;

      var wrap = document.createElement('span');
      wrap.className = wrapClass;

      if (mode === 'badge') {
        var text = node.middleBadgeText || '';
        if (!text) return null;
        wrap.classList.add('koz-shop-with-mike__middle-badge');
        wrap.textContent = text;
        return wrap;
      }

      var imgSrc = nodeMiddleImage(node, root);
      if (!imgSrc) return null;

      wrap.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.className = wrapClass + '-img';
      img.src = imgSrc;
      img.alt = '';
      img.loading = 'lazy';
      wrap.appendChild(img);
      return wrap;
    }

    function renderCollectionBadge(node, className) {
      var text = collectionBadgeText(node, root);
      if (!text) return null;
      var badge = document.createElement('span');
      badge.className = className || 'koz-shop-with-mike__collection-badge';
      badge.textContent = text;
      return badge;
    }

    function attachChoiceHandler(el, childNode, path) {
      el.addEventListener('click', function () {
        if (childNode.disableNavigation) {
          setNotice(comingSoonMsg);
          return;
        }
        if (shouldAutoRedirect(childNode)) {
          redirectToDestination(childNode);
          return;
        }
        navigateTo(childPath(path, childNode.id), true);
      });
    }

    function renderChoiceCard(childNode, path) {
      if (isMinimalLayout()) {
        return renderChoiceRow(childNode, path);
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'koz-shop-with-mike__card';
      if (isStackedCard(root)) {
        btn.classList.add('koz-shop-with-mike__card--stacked');
      }
      btn.setAttribute('role', 'listitem');

      if (childNode.disableNavigation) {
        btn.classList.add('koz-shop-with-mike__card--disabled');
        btn.setAttribute('aria-disabled', 'true');
      }

      var imgSrc = nodeLeftImage(childNode);
      var media = document.createElement('span');
      media.className = 'koz-shop-with-mike__card-media';

      if (imgSrc) {
        var img = document.createElement('img');
        img.className = 'koz-shop-with-mike__card-img';
        img.src = imgSrc;
        img.alt = '';
        img.loading = 'lazy';
        img.setAttribute('aria-hidden', 'true');
        media.appendChild(img);
      }

      var collBadge = renderCollectionBadge(childNode, 'koz-shop-with-mike__collection-badge');
      if (collBadge) {
        media.appendChild(collBadge);
      }

      if (isStackedCard(root)) {
        btn.appendChild(media);

        if (isMiddleEnabledForCard(root)) {
          var stackedMiddle = renderMiddleContent(childNode, 'koz-shop-with-mike__card-middle');
          if (stackedMiddle) {
            var middleWrap = document.createElement('span');
            middleWrap.className = 'koz-shop-with-mike__card-middle-wrap';
            middleWrap.appendChild(stackedMiddle);
            btn.appendChild(middleWrap);
          }
        }

        var content = document.createElement('span');
        content.className = 'koz-shop-with-mike__card-content';

        var title = document.createElement('span');
        title.className = 'koz-shop-with-mike__card-title';
        title.textContent = nodeTitle(childNode);
        content.appendChild(title);

        var linkLabel = document.createElement('span');
        linkLabel.className = 'koz-shop-with-mike__card-link';
        linkLabel.textContent = childNode.disableNavigation ? comingSoonMsg : chooseLabel(root);
        content.appendChild(linkLabel);

        btn.appendChild(content);
      } else {
        if (media.childNodes.length) {
          btn.appendChild(media);
        }

        var overlay = document.createElement('span');
        overlay.className = 'koz-shop-with-mike__card-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        btn.appendChild(overlay);

        var contentOverlay = document.createElement('span');
        contentOverlay.className = 'koz-shop-with-mike__card-content';

        if (isMiddleEnabledForCard(root)) {
          var overlayMiddle = renderMiddleContent(childNode, 'koz-shop-with-mike__card-middle');
          if (overlayMiddle) {
            contentOverlay.appendChild(overlayMiddle);
          }
        }

        var titleOverlay = document.createElement('span');
        titleOverlay.className = 'koz-shop-with-mike__card-title';
        titleOverlay.textContent = nodeTitle(childNode);
        contentOverlay.appendChild(titleOverlay);

        var linkLabelOverlay = document.createElement('span');
        linkLabelOverlay.className = 'koz-shop-with-mike__card-link';
        linkLabelOverlay.textContent = childNode.disableNavigation ? comingSoonMsg : chooseLabel(root);
        contentOverlay.appendChild(linkLabelOverlay);

        btn.appendChild(contentOverlay);
      }

      attachChoiceHandler(btn, childNode, path);
      return btn;
    }

    function renderChoiceRow(childNode, path) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'koz-shop-with-mike__row';
      btn.setAttribute('role', 'listitem');

      if (childNode.disableNavigation) {
        btn.classList.add('koz-shop-with-mike__row--disabled');
        btn.setAttribute('aria-disabled', 'true');
      }

      var iconWrap = buildLeftIcon(nodeLeftImage(childNode));

      var middleEnabled = isMiddleEnabledForRow(root);
      var middleAlign = getMiddleAlign(root);
      var middleEl = middleEnabled ? renderMiddleContent(childNode, 'koz-shop-with-mike__row-middle-icon') : null;

      var body = document.createElement('span');
      body.className = 'koz-shop-with-mike__row-body';

      var collBadgeRow = renderCollectionBadge(childNode, 'koz-shop-with-mike__collection-badge koz-shop-with-mike__collection-badge--inline');
      if (collBadgeRow) {
        body.appendChild(collBadgeRow);
      }

      var title = document.createElement('span');
      title.className = 'koz-shop-with-mike__row-title';
      title.textContent = nodeTitle(childNode);

      if (middleEnabled && middleAlign === 'left' && middleEl) {
        var titleRow = document.createElement('span');
        titleRow.className = 'koz-shop-with-mike__row-title-row';
        titleRow.appendChild(title);
        titleRow.appendChild(middleEl);
        body.appendChild(titleRow);
        middleEl = null;
      } else {
        body.appendChild(title);
      }

      if (childNode.description) {
        var description = document.createElement('span');
        description.className = 'koz-shop-with-mike__row-description';
        description.textContent = childNode.description;
        body.appendChild(description);
      }

      var action = document.createElement('span');
      action.className = 'koz-shop-with-mike__row-btn';
      action.textContent = childNode.disableNavigation ? comingSoonMsg : chooseLabel(root);

      if (middleEnabled && middleAlign === 'center') {
        var start = document.createElement('span');
        start.className = 'koz-shop-with-mike__row-start';
        if (iconWrap) start.appendChild(iconWrap);
        start.appendChild(body);
        btn.appendChild(start);

        if (middleEl) {
          btn.appendChild(middleEl);
        } else {
          var middlePlaceholder = document.createElement('span');
          middlePlaceholder.className = 'koz-shop-with-mike__row-middle-icon koz-shop-with-mike__row-middle-icon--empty';
          middlePlaceholder.setAttribute('aria-hidden', 'true');
          btn.appendChild(middlePlaceholder);
        }

        btn.appendChild(action);
      } else {
        var startFlex = document.createElement('span');
        startFlex.className = 'koz-shop-with-mike__row-start';
        if (iconWrap) startFlex.appendChild(iconWrap);
        startFlex.appendChild(body);
        btn.appendChild(startFlex);
        if (middleEnabled && middleAlign === 'right' && middleEl) {
          btn.appendChild(middleEl);
        }
        btn.appendChild(action);
      }

      attachChoiceHandler(btn, childNode, path);
      return btn;
    }

    function renderGridChildren(node, path) {
      if (!gridEl) return;
      gridEl.innerHTML = '';
      var children = node.children || [];
      children.forEach(function (childId) {
        var childNode = tree.nodes[childId];
        if (!childNode) return;
        gridEl.appendChild(renderChoiceCard(childNode, path));
      });
    }

    function showBranch(node, path) {
      if (introEl) introEl.setAttribute('hidden', '');
      if (branchEl) branchEl.removeAttribute('hidden');
      if (leafEl) leafEl.setAttribute('hidden', '');
      setBackVisible(true);

      if (stepHeading) {
        stepHeading.textContent = nodeTitle(node);
        stepHeading.removeAttribute('hidden');
        focusFunnelHeading(stepHeading);
      }

      renderGridChildren(node, path);
      announce(nodeTitle(node));
    }

    function showLeaf(node) {
      if (introEl) introEl.setAttribute('hidden', '');
      if (branchEl) branchEl.setAttribute('hidden', '');
      if (leafEl) leafEl.removeAttribute('hidden');
      setBackVisible(true);

      if (leafHeading) {
        leafHeading.textContent = nodeTitle(node);
        focusFunnelHeading(leafHeading);
      }
      if (leafBody) {
        leafBody.textContent = node.description || '';
      }
      if (leafCta) {
        leafCta.textContent = leafCtaLabel(root, node);
        leafCta.href = leafUrl(node, root);
      }

      announce(nodeTitle(node));
    }

    function showHubIntro(node) {
      if (introEl) introEl.removeAttribute('hidden');
      if (branchEl) branchEl.removeAttribute('hidden');
      if (leafEl) leafEl.setAttribute('hidden', '');
      setBackVisible(false);

      if (stepHeading) {
        stepHeading.textContent = '';
        stepHeading.setAttribute('hidden', '');
      }

      focusFunnelHeading(root.querySelector('[data-funnel-intro-heading]'));

      renderGridChildren(node, []);
      announce(node.title || 'Shop with Mike');
    }

    function showFunnelRootStart(node) {
      if (introEl) introEl.removeAttribute('hidden');
      if (branchEl) branchEl.removeAttribute('hidden');
      if (leafEl) leafEl.setAttribute('hidden', '');
      setBackVisible(false);

      if (stepHeading) {
        stepHeading.textContent = '';
        stepHeading.setAttribute('hidden', '');
      }

      focusFunnelHeading(root.querySelector('[data-funnel-intro-heading]'));

      renderGridChildren(node, []);
      announce(node.title || 'Shop with Mike');
    }

    function navigateTo(path, pushHistory) {
      setNotice('');
      pathSegments = path.slice();

      var resolved = resolveNode(tree, pathSegments, funnelRoot);
      if (!resolved.valid || !resolved.node) {
        pathSegments = [];
        setNotice(root.getAttribute('data-msg-invalid-path') || 'Invalid path.');
        resolved = resolveNode(tree, [], funnelRoot);
      }

      var node = resolved.node;
      renderBreadcrumb(pathSegments);

      if (pushHistory !== false) {
        updateUrl(pathSegments, false);
      }

      if (!pathSegments.length) {
        if (funnelRoot) {
          showFunnelRootStart(node);
        } else {
          showHubIntro(node);
        }
        return;
      }

      if (shouldAutoRedirect(node)) {
        redirectToDestination(node);
        return;
      }

      if (isLeafType(node.type)) {
        showLeaf(node);
      } else {
        showBranch(node, pathSegments);
      }
    }

    function goBack() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        navigateTo([], false);
      }
    }

    function syncFromPath() {
      pathSegments = getPathFromSearch();
      var resolved = resolveNode(tree, pathSegments, funnelRoot);
      if (!resolved.valid) {
        pathSegments = [];
        setNotice(root.getAttribute('data-msg-invalid-path') || 'Invalid path.');
      }
      renderBreadcrumb(pathSegments);
      var node = resolveNode(tree, pathSegments, funnelRoot).node;
      if (!pathSegments.length) {
        if (funnelRoot) {
          showFunnelRootStart(node);
        } else {
          showHubIntro(node);
        }
      } else if (isLeafType(node.type)) {
        showLeaf(node);
      } else {
        showBranch(node, pathSegments);
      }
    }

    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }

    window.addEventListener('popstate', syncFromPath);

    pathSegments = getPathFromSearch();
    var initial = resolveNode(tree, pathSegments, funnelRoot);
    if (!initial.valid) {
      pathSegments = [];
      setNotice(root.getAttribute('data-msg-invalid-path') || 'Invalid path.');
    }
    updateUrl(pathSegments, true);
    navigateTo(pathSegments, false);
    readyForFocus = true;
  }

  function init(root) {
    var tree = parseJson(root, 'script[data-funnel-tree]');
    var noticeEl = root.querySelector('[data-funnel-notice]');

    if (!tree || !tree.nodes) {
      if (noticeEl) {
        noticeEl.textContent =
          root.getAttribute('data-msg-invalid-path') ||
          'Unable to load the Shop with Mike journey. Please refresh the page.';
        noticeEl.removeAttribute('hidden');
      }
      return;
    }

    if (tree.nodes) {
      Object.keys(tree.nodes).forEach(function (id) {
        var node = tree.nodes[id];
        if (node && node.url) {
          node.url = normalizeUrl(node.url);
        }
      });
    }

    bootstrapFunnel(root, tree);
  }

  document.querySelectorAll('[data-koz-shop-with-mike]').forEach(init);
})();
